import { StateStatus } from '../../../../shared/infrastructure/store/utils/state_status';
import Bank from '../../domain/entities/bank';

interface Props {
    status?: StateStatus;
    banks?: Bank[];
    error?: string;
}

class BanksState {
    status: StateStatus;
    banks: Bank[];
    error: string;

    constructor(props: Props) {
        const { status, banks, error } = props;

        this.status = status ?? StateStatus.initial;
        this.banks = banks ?? [];
        this.error = error ?? undefined;
    }

    copyWith(props: Props) {
        const { status, banks, error } = props;

        return new BanksState({
            status: status ?? this.status,
            banks: banks ?? this.banks,
            error: error ?? this.error
        });
    }
}

export default BanksState;
